import { IComponentController } from 'angular';
import { IEcranDetailsResourcesEntite } from '../../../../../core/resources/ecran-details.resource';
import { IFormulaireItemClass } from '../../../../../core/services/formulaire/formulaire-item.service';
import { IFormulaire, IFormulaireClass } from '../../../../../core/services/formulaire/formulaire.service';
import { IMonoOccurrence, IMonoOccurrenceOptions } from '../../../../../core/services/mono-occurrence.service';
import { IMultiOccurrenceOptions } from '../../../../../core/services/multi-occurrence.service';
import { IFormulaireItemSautDeLigneClass } from '../../../../../core/services/formulaire/formulaire-item-saut-de-ligne.service';
import { IFormulaireGroupeClass } from '../../../../../core/services/formulaire/formulaire-groupe.service';
import { IStateParamsService } from 'angular-ui-router';
import { IMenuItemActionClass } from '../../../../../core/services/menu/menu-item-action.service';
import { IMenuItemEcranClass } from '../../../../../core/services/menu/menu-item-ecran.service';
import { IRoute } from '../../../../../core/interfaces/route.interface';
import { IMenuClass } from '../../../../../core/services/menu/menu.service';
import { IMenuItemActionTelechargementClass } from '../../../../../core/services/menu/menu-item-action-telechargement.service';
import { IMenuItemForageClass } from '../../../../../core/services/menu/menu-item-forage.service';

interface IPageAl0006 extends IComponentController {
    monoOccurrence: IMonoOccurrence;
    monoOccurrenceOptions: IMonoOccurrenceOptions;
    davMultiOccurrenceOptions: IMultiOccurrenceOptions;
    dcqMultiOccurrenceOptions: IMultiOccurrenceOptions;
    darMultiOccurrenceOptions: IMultiOccurrenceOptions;
    formulaireCriteres: IFormulaire;
    valeursEcran: any;
}

/* @ngInject */
export default function Al0006Controller(
    Formulaire: IFormulaireClass,
    al2014Route: IRoute,
    ecranDetails: IEcranDetailsResourcesEntite,
    FormulaireItem: IFormulaireItemClass,
    FormulaireItemSautDeLigne: IFormulaireItemSautDeLigneClass,
    FormulaireGroupe: IFormulaireGroupeClass,
    MenuItemForage: IMenuItemForageClass,
    $stateParams: IStateParamsService,
    MenuItemActionTelechargement: IMenuItemActionTelechargementClass,
    MenuItemEcran: IMenuItemEcranClass,
    MenuItemAction: IMenuItemActionClass,
    Menu: IMenuClass,
    al2010Route: IRoute
) {
    const vm: IPageAl0006 = this;

    vm.valeursEcran = ecranDetails.valeurs;

    //Calcule des avantages
    vm.btnMenus = [
        new MenuItemAction("LBL_BTN_CAL", "BOUCALAV", () => ({flg_debug: vm.valeursEcran.flg_debug}),
            {
                iconButton: false,
                icon: ' ',
                secondaire: true,
                successAction: () => { vm.monoOccurrence.fetchData() }
            }),
        new MenuItemEcran("", al2010Route.NAME, () => ({ecran: '00-2',}),
            {
                iconButton: true,
                icon: (data: any) => data.inc_nbr > 0 ? "warning" : ' ',
                hidden: (data: any) => data.inc_nbr > 0 ? false : true,
                compteur: (data: any) => data.inc_nbr > 0 ? data.inc_nbr : undefined
            }
        ),
        new MenuItemActionTelechargement('LBL_BTN_EXP', 'BOUEXPORT', () => ({}), {
            iconButton: false,
            icon: ' ',
            secondaire: true
        })
    ];

    const actionsMoreLigne = new Menu([          
        new MenuItemAction('LBL_BTN_ACTIVE', 'BOUFLG', () => ({flg_debug: vm.valeursEcran.flg_debug}), {
            icon: 'bug_report',
            hidden: () => vm.valeursEcran.flgaffdbg === 0,
            successAction: (data: any) => {
                vm.valeursEcran.flg_debug = 1;
                vm.valeursEcran.flgaffdbg = 0;
                vm.monoOccurrence.fetchData();                    
            }
        }),
        new MenuItemAction('LBL_BTN_DESACTIVE', 'BOUFLG', () => ({flg_debug: vm.valeursEcran.flg_debug}), {
            icon: 'bug_report',
            hidden: () => vm.valeursEcran.flgaffdbg === 1 || vm.valeursEcran.flg_debug === 0,
            successAction: (data: any) => {
                vm.valeursEcran.flg_debug = 0;
                vm.valeursEcran.flgaffdbg = 1;
                vm.monoOccurrence.fetchData();
            }
        }),
        new MenuItemForage(
            'LBL_AL2014',
            al2014Route.NAME,
            () => ({ ecran: '00-2' }),
            {
                icon: 'assessment',
                iconButton: false,
                hidden: () => vm.valeursEcran.flgaffdbg === 1 || vm.valeursEcran.flg_debug === 0,
                linkExterne: true
            }
        )
    ]);
    vm.monoOccurrenceOptions = {
        actionsMore: actionsMoreLigne,
        fonctions: {
            exportation: true
        }        
    }
    vm.formulaireDfc = new Formulaire('Facturation ALD des avantages', [
        new FormulaireItem('dalcleint', {
            largeur: 33,
            required: false,
            default: $stateParams.dalcleint,
            disabled: true,
            hidden: true
        }),
        new FormulaireItem('demcleint', {
            largeur: 33,
            required: false,
            default: $stateParams.demcleint,
            disabled: true
        }),
        new FormulaireItem('eadcleint', {
            largeur: 33,
            required: false,
            disabled: false,
            resourceParams: (data: any) => ({ demcleint: $stateParams.demcleint }),
            default: vm.valeursEcran.eadcleint
        }),
        new FormulaireGroupe('Assume la part employeur', new Formulaire([
            new FormulaireItem('dfcflgemrass', {
                largeur: 33,
                default: vm.valeursEcran.dfcflgemrass,
                required: false
            }),
            new FormulaireItem('dfcflgemrfpn', {
                largeur: 33,
                default: vm.valeursEcran.dfcflgemrfpn,
                required: false
            })
        ])),
        new FormulaireItemSautDeLigne(),
        new FormulaireGroupe('Inclure la part employé', new Formulaire([
            new FormulaireItem('dfcflgempass', {
                largeur: 33,
                default: vm.valeursEcran.dfcflgempass,
                required: false
            }),
            new FormulaireItem('dfcflgempfpn', {
                largeur: 33,
                default: vm.valeursEcran.dfcflgempfpn,
                required: false
            })
        ])),
        new FormulaireItemSautDeLigne(),
        new FormulaireGroupe('Dates', new Formulaire([
            new FormulaireItem('dfcdatdeb', {
                largeur: 33,
                required: true
            }),
            new FormulaireItem('dfcdatfin', {
                largeur: 33,
                required: true
            }),
            new FormulaireItem('dfcdatenv', {
                largeur: 33,
                required: false,
                default: vm.valeursEcran.dfcdatenv
            }),
            new FormulaireItem('dfcprcabs', {
                largeur: 33,
                required: true
            }),
            new FormulaireItem('vaedfchor', {
                largeur: 33,
                required: true,
                default: vm.valeursEcran.vaedfchor
            }),
            new FormulaireItem('tagcleint', {
                largeur: 33,
                required: false
            }),
            new FormulaireItemSautDeLigne(),
            new FormulaireItem('vacdfcrmb', {
                largeur: 33,
                required: false
            })
        ]))
    ]);
    vm.davMultiOccurrenceOptions = {
        bloc: 'dav',
        colonnesVisibles: [
            { nom: 'placoddch', largeur: 220 },
            { nom: 'cod_option', largeur: 130 },
            { nom: 'desc_option', largeur: 130 },
            { nom: 'davflggar', largeur: 130 },
            { nom: 'davsaladm', largeur: 130 },
            { nom: 'davmntemp', largeur: 130 },
            { nom: 'davmntemr', largeur: 130 },
            { nom: 'davmntempppa', largeur: 130 },
            { nom: 'davmntemptot', largeur: 130 },
            { nom: 'cod_s_option', largeur: 130 },
            { nom: 'desc_s_option', largeur: 130 }
        ],
        formulaire: new Formulaire([
            new FormulaireItem('cod_option', {
                largeur: 33
            }),
            new FormulaireItem('desc_option', {
                largeur: 33
            }),
            new FormulaireItem('davflggar', {
                largeur: 33
            }),
            new FormulaireItem('davsaladm', {
                largeur: 33
            }),
            new FormulaireItem('davmntemp', {
                largeur: 33
            }),
            new FormulaireItem('davmntemr', {
                largeur: 33
            }),
            new FormulaireItem('davmntempppa', {
                largeur: 33
            }),
            new FormulaireItem('davmntemptot', {
                largeur: 33
            }),
            new FormulaireItem('cod_s_option', {
                largeur: 33
            }),
            new FormulaireItem('desc_s_option', {
                largeur: 33
            })
        ])
    }

    vm.dcqMultiOccurrenceOptions = {
        bloc: 'dcq',
        colonnesVisibles: [
            { nom: 'dcqnumref', largeur: 130 },
            { nom: 'dcqmnt', largeur: 130 },
            { nom: 'dcqdat', largeur: 130 },
            { nom: 'dcqdattrt', largeur: 130 }
        ],
        colonnesCachees: ['dfccleint'],
        formulaire: new Formulaire([
            new FormulaireItem('dcqnumref', {
                largeur: 33,
                required: true,
            }),
            new FormulaireItem('dcqmnt', {
                largeur: 33,
                required: true,
            }),
            new FormulaireItem('dcqdat', {
                largeur: 33,
                required: true,
            }),
            new FormulaireItem('dcqdattrt', {
                largeur: 33,
                required: false,
                disabled: true
            })
        ])
    };

    vm.darMultiOccurrenceOptions = {
        bloc: 'dar',
        colonnesVisibles: [
            { nom: 'rcecod', largeur: 130 },
            { nom: 'rcedscabr', largeur: 130 },
            { nom: 'darmntarr', largeur: 130 },
            { nom: 'darmntmaxrec', largeur: 130 }
        ],
        formulaire: new Formulaire([
            new FormulaireItem('rcecleint', {
                largeur: 33
            }),
            new FormulaireItem('darmntarr', {
                largeur: 33
            }),
            new FormulaireItem('darmntmaxrec', {
                largeur: 33
            })
        ])
    };
}
